import { render, staticRenderFns } from "./ViewQuestion.vue?vue&type=template&id=1602382a"
import script from "./ViewQuestion.vue?vue&type=script&lang=js"
export * from "./ViewQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports